var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagNamibia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68634 27.3137C5.35752 27.9849 6.07365 28.5835 6.82484 29.1105L29.1104 6.82484C28.5835 6.07365 27.9849 5.35752 27.3136 4.68634C26.6425 4.01515 25.9263 3.41665 25.1751 2.88965L2.88965 25.1753C3.41659 25.9263 4.01515 26.6425 4.68634 27.3137Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68668 4.68629C-0.361066 9.73404 -1.33007 17.3148 1.77762 23.3362L23.3365 1.77735C17.3151 -1.33034 9.73431 -0.361212 4.68668 4.68629Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3137 27.3137C32.3613 22.2661 33.3303 14.6853 30.2228 8.66382L8.66388 30.2227C14.6852 33.3304 22.266 32.3614 27.3137 27.3137Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2178 9.04357L11.4249 9.88688L12.3796 11.6233L10.4328 11.2509L10.1861 13.2174L8.83007 11.771L7.47401 13.2174L7.22738 11.2509L5.28051 11.6232L6.2352 9.88682L4.44238 9.04357L6.23526 8.20019L5.28051 6.46394L7.22732 6.83632L7.47407 4.86963L8.83007 6.31613L10.1861 4.86963L10.4328 6.83632L12.3796 6.46394L11.425 8.20025L13.2178 9.04357Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagNamibia);
export default __webpack_public_path__ + "static/media/flag_namibia.a37f5630a4f8d10be182c611d51ceb8a.svg";
export { ForwardRef as ReactComponent };